import "@mdi/font/css/materialdesignicons.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";
import MondayIcon from "@/components/MondayIcon.vue";
import MFilesIcon from "@/components/MFilesIcon.vue";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi", // default - only for display purposes,
    values: {
      mondayicon: {
        // name of our custom icon
        component: MondayIcon // our custom component
      },
      mfilesicon: {
        // name of our custom icon
        component: MFilesIcon // our custom component
      }
    }
  },
  /* BS */
  /*theme: {
    themes: {
      light: {
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        primary: "#DA2128",
        secondary: "#424242",
        success: "#4CAF50",
        warning: "#FB8C00"
      },
      dark: {
        accent: "#FF4081",
        error: "#FF5252",
        info: "#2196F3",
        primary: "#DA2128",
        secondary: "#424242",
        success: "#4CAF50",
        warning: "#FB8C00"
      }
    }
  }*/
  /* Defualt Soluma */
  theme: {
    themes: {
      light: {
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        primary: "#1976D2",
        secondary: "#424242",
        success: "#4CAF50",
        warning: "#FB8C00"
      },
      dark: {
        accent: "#FF4081",
        error: "#FF5252",
        info: "#2196F3",
        primary: "#2196F3",
        secondary: "#424242",
        success: "#4CAF50",
        warning: "#FB8C00"
      }
    }
  }
});
